module.exports = __webpack_public_path__ + "static/011.thumb-912b78eddc5c0065195aa4b844fffa1e.jpg";